import React from 'react';

function Icon() {
  return (
    <svg width="92" height="93" fill="none" viewBox="0 0 92 93">
      <path
        fill="url(#paint0_linear_scale)"
        d="M55.253 86.617H33.691V35.408a2.695 2.695 0 012.695-2.695h16.172a2.695 2.695 0 012.695 2.695v51.21z"></path>
      <path
        fill="#C5B0FF"
        d="M27.942 86.617H6.38V46.19a2.695 2.695 0 012.695-2.695h16.171a2.695 2.695 0 012.696 2.695v40.428z"></path>
      <path
        fill="url(#paint1_linear_scale)"
        d="M73.513 1.004a2.674 2.674 0 00-4.177 0L53.339 21a2.675 2.675 0 002.089 4.346h5.216v61.271h21.562V25.346h5.215A2.675 2.675 0 0089.51 21L73.513 1.004z"></path>
      <path
        fill="url(#paint2_linear_scale)"
        d="M89.302 92.008H2.695A2.695 2.695 0 010 89.313v-2.695a5.39 5.39 0 015.39-5.391h81.217a5.39 5.39 0 015.39 5.39v2.696a2.695 2.695 0 01-2.695 2.695z"></path>
      <defs>
        <linearGradient
          id="paint0_linear_scale"
          x1="60.839"
          x2="55.398"
          y1="97.936"
          y2="17.806"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#A788FF"></stop>
          <stop offset="1" stopColor="#A788FF" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_scale"
          x1="71.424"
          x2="123.161"
          y1="0"
          y2="138"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#8A61FF"></stop>
          <stop offset="1" stopColor="#8A61FF" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_scale"
          x1="-9.893"
          x2="125.14"
          y1="87.054"
          y2="97.936"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#DBCEFF"></stop>
          <stop offset="1" stopColor="#F2EDFF"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default Icon;
